import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Components
import reportWebVitals from './reportWebVitals';

// Utilities
import React from 'react';
import App from 'src/App';
import SnackbarGlobal from 'src/components/common/Snackbar';
import GlobalBoundaryFallback from 'src/components/ErrorBoundary/GlobalBoundary';
import GlobalLoading from 'src/components/GlobalLoading';
import { queryClient } from 'src/configs/queryClient';
import StripeProvider from 'src/contexts/StripeProvider';
import 'src/sentry';
import ThemeCustomization from 'src/themes';
import './index.css';

const SentryApp = Sentry.withProfiler(App);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Suspense fallback={<GlobalLoading />}>
    <Sentry.ErrorBoundary
      fallback={({ error, componentStack, eventId }) => (
        <GlobalBoundaryFallback error={error} componentStack={componentStack} eventId={eventId} />
      )}
      showDialog={false}
    >
      <ThemeCustomization>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BrowserRouter>
            <StripeProvider>
              <QueryClientProvider client={queryClient}>
                {(process.env.NODE_ENV === 'development' && (
                  <>
                    <SentryApp />
                    <ReactQueryDevtools initialIsOpen={false} />
                  </>
                )) || <SentryApp />}
                <SnackbarGlobal />
              </QueryClientProvider>
            </StripeProvider>
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeCustomization>
    </Sentry.ErrorBoundary>
  </React.Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
